<template>
    <button @click="continueShopping" class="vc-checkout-continue c-button c-button--text" :class="animationClass">
        <font-awesome-icon class="c-button__left-icon" icon="chevron-left"></font-awesome-icon>
        Continue Shopping
    </button>
</template>

<script>
    export default {
        name: "checkout-continue-shopping",
        computed: {
            animationClass() {
                return  {
                    'c-button--animate-icon-left-right-all-time' : this.$store.getters['checkout/continueShoppingButtonAnimation']
                }
            }
        },
        methods: {
            continueShopping() {
                this.$router.push('/');
            }
        }
    }
</script>

<style lang="scss" scoped>
    .vc-checkout-continue {
        padding:{
            top: 2px;
            bottom: 2px;
        };
    }
</style>